import { render, staticRenderFns } from "./BasePaginationTrigger.vue?vue&type=template&id=073f18c8&scoped=true"
import script from "./BasePaginationTrigger.vue?vue&type=script&lang=js"
export * from "./BasePaginationTrigger.vue?vue&type=script&lang=js"
import style0 from "./BasePaginationTrigger.vue?vue&type=style&index=0&id=073f18c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073f18c8",
  null
  
)

export default component.exports